import { Spin } from "antd";
import React, { useEffect, useState } from "react";
import ReactECharts from "echarts-for-react";
import { useUserPermissions } from "../../../UserPermissionsContext";
import Cookies from "js-cookie";

const WeeklySalesChart = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [chartOption, setChartOption] = useState<any>(null);
  const [ConversionchartOption, setConversionChartOption] = useState<any>(null);
  const { webApi } = useUserPermissions();

  const jwtToken = Cookies.get("authToken");

  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  const fetchSales = async () => {
    setIsLoading(true);

    try {
      const response = await fetch(
        `${webApi}/sed/get_weekly_sales_graph/`,
        options,
      );

      const data = await response.json();
      const results = data.results;

      const labels = results.map((item: any) => item.label);
      // const sales = results.map((item: any) => item.sales);
      const ets = results.map((item: any) => item.ets);
      const scts = results.map((item: any) => item.scts);

      setChartOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          top: 10,
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: labels,
        },
        yAxis: {
          type: "value",
          name: "Count",
        },
        series: [
          // {
          //   name: "Sales",
          //   type: "bar",
          //   data: sales,
          //   barGap: "20%",
          // },
          {
            name: "SCTS",
            type: "bar",
            stack: "combined",
            data: scts,
            barWidth: 20,
            itemStyle: {
              color: "#3C83F6",
            },
          },
          {
            name: "ETS",
            type: "bar",
            stack: "combined",
            data: ets,
            barWidth: 20,
            itemStyle: {
              color: "#3CF677",
            },
          },
        ],
      });
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchWeeklyConversionAgent = async () => {
    setIsLoading(true);

    try {
      const response = await fetch(
        `${webApi}/sed/get_weekly_conversation_duration_graph/`,
        options,
      );

      const data = await response.json();
      const results = data.results;

      const labels = results.map((item: any) => item.label);
      // const sales = results.map((item: any) => item.sales ?? 0);
      const scts_duration = results.map((item: any) => item.scts_duration ?? 0);
      const ets_duration = results.map((item: any) => item.ets_duration ?? 0);

      setConversionChartOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          top: 1,
        },
        grid: {
          left: "2%",
          right: "3%",
          bottom: "2%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: labels,
        },
        yAxis: {
          type: "value",
          name: "Count",
        },
        series: [
          // {
          //   name: "Sales",
          //   type: "bar",
          //   data: sales ?? 0,
          //   barGap: "15%",
          // },
          {
            name: "SCTS",
            type: "bar",
            stack: "combined",
            data: scts_duration ?? 0,
            barWidth: 20,
            itemStyle: {
              color: "#3C83F6",
            },
          },
          {
            name: "ETS",
            type: "bar",
            stack: "combined",
            data: ets_duration ?? 0,
            barWidth: 20,
            itemStyle: {
              color: "#3CF677",
            },
          },
        ],
      });
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchSales();
    fetchWeeklyConversionAgent();
  }, []);

  return (
    <div className="row">
      <div className="col-xxl-6 col-xl-6 d-flex">
        <div className="card flex-fill">
          <div className="card-header">
            <h4 className="card-title">Weekly Sales</h4>
          </div>

          <div className="card-body">
            {isLoading ? (
              <div
                style={{
                  height: 350,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Spin />
              </div>
            ) : (
              chartOption && (
                <ReactECharts option={chartOption} style={{ height: 350 }} />
              )
            )}
          </div>
        </div>
      </div>

      {/* weekly conversion of Agent */}
      <div className="col-xxl-6 col-xl-6 d-flex">
        <div className="card flex-fill">
          <div className="card-header">
            <h4 className="card-title">Weekly Conversation Of Agent</h4>
          </div>

          <div className="card-body">
            {isLoading ? (
              <div
                style={{
                  height: 350,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Spin />
              </div>
            ) : (
              ConversionchartOption && (
                <ReactECharts
                  option={ConversionchartOption}
                  style={{ height: 350 }}
                />
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WeeklySalesChart;
